/**
 * Navigation Wrap Detector
 * Detects when navigation items would wrap to a new line
 * and automatically switches to hamburger menu
 */
class NavigationWrapDetector {
  constructor() {
    this.navMenu = null;
    this.hamburgerButton = null;
    this.originalDisplay = null;
    this.init();
  }

  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setup());
    } else {
      this.setup();
    }
  }

  setup() {
    // Find the navigation menu
    this.navMenu = document.querySelector('.header__inline-menu');
    if (!this.navMenu) return;

    // Find the hamburger menu button (header-drawer)
    this.hamburgerButton = document.querySelector('header-drawer');
    if (!this.hamburgerButton) return;

    // Store original display style
    this.originalDisplay = window.getComputedStyle(this.navMenu).display;

    // Check on load
    this.checkWrap();

    // Check on resize with debounce
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        this.checkWrap();
      }, 100);
    });

    // Also check after a short delay to catch any dynamic content
    setTimeout(() => this.checkWrap(), 500);
  }

  checkWrap() {
    if (!this.navMenu || !this.hamburgerButton) return;

    // Only check on desktop (min-width: 990px based on custom.css)
    if (window.innerWidth < 990) {
      // On mobile, ensure hamburger is visible and nav is hidden
      this.navMenu.classList.add('nav-wrap-hidden');
      this.hamburgerButton.classList.remove('nav-wrap-active');
      return;
    }

    // Temporarily show menu to measure it
    const wasHidden = this.navMenu.classList.contains('nav-wrap-hidden');
    this.navMenu.classList.remove('nav-wrap-hidden');
    this.navMenu.style.visibility = 'hidden';
    this.navMenu.style.position = 'absolute';
    this.navMenu.style.top = '-9999px';
    this.navMenu.style.display = this.originalDisplay || 'flex';

    // Force a reflow
    this.navMenu.offsetHeight;

    // Get the parent container
    const header = this.navMenu.closest('.header');
    if (!header) {
      this.navMenu.style.visibility = '';
      this.navMenu.style.position = '';
      this.navMenu.style.top = '';
      return;
    }

    // Get available width
    const headerRect = header.getBoundingClientRect();
    const headerWidth = headerRect.width;
    
    // Find logo/left side
    const headerLeft = header.querySelector('.header__heading, .header__left');
    const headerRight = header.querySelector('.header__right');
    
    let leftWidth = 0;
    let rightWidth = 0;
    
    if (headerLeft) {
      const leftRect = headerLeft.getBoundingClientRect();
      leftWidth = leftRect.width + (headerRect.left - leftRect.left);
    }
    
    if (headerRight) {
      const rightRect = headerRight.getBoundingClientRect();
      rightWidth = headerRect.right - rightRect.left;
    }
    
    // Calculate available space (with padding)
    const availableWidth = headerWidth - leftWidth - rightWidth - 80; // 80px buffer for padding/margins

    // Measure the navigation menu's natural width
    const menuWidth = this.navMenu.scrollWidth;
    const menuList = this.navMenu.querySelector('.list-menu--inline');
    const menuListWidth = menuList ? menuList.scrollWidth : menuWidth;

    // Restore styles
    this.navMenu.style.visibility = '';
    this.navMenu.style.position = '';
    this.navMenu.style.top = '';

    // Check if menu would wrap by comparing widths
    let wouldWrap = menuListWidth > availableWidth;
    
    // Additional check: see if items are actually wrapping by checking positions
    if (menuItems.length > 0) {
      // Restore display temporarily to check actual positions
      this.navMenu.style.visibility = 'visible';
      this.navMenu.style.position = 'relative';
      this.navMenu.style.top = '';
      
      // Force a reflow
      this.navMenu.offsetHeight;
      
      const firstItem = menuItems[0];
      const lastItem = menuItems[menuItems.length - 1];
      
      if (firstItem && lastItem) {
        const firstRect = firstItem.getBoundingClientRect();
        const lastRect = lastItem.getBoundingClientRect();
        
        // If last item is significantly below first item, they're wrapping
        if (lastRect.top > firstRect.top + 5) {
          wouldWrap = true;
        }
      }
      
    }

    // Restore all styles
    this.navMenu.style.visibility = '';
    this.navMenu.style.position = '';
    this.navMenu.style.top = '';

    if (wouldWrap) {
      // Menu would wrap - hide it and show hamburger
      this.navMenu.classList.add('nav-wrap-hidden');
      this.hamburgerButton.classList.add('nav-wrap-active');
    } else {
      // Menu fits - show it and hide hamburger
      this.navMenu.classList.remove('nav-wrap-hidden');
      this.hamburgerButton.classList.remove('nav-wrap-active');
    }
  }
}

// Initialize
new NavigationWrapDetector();
